function o(r,e,n=1){const{amount:t,currencyCode:c}=r;return new Intl.NumberFormat(e,{style:"currency",currency:c}).format(t*n)}export{o as formatPrice};
//# sourceMappingURL=format-price.js.map
